import React, { useState } from 'react';
import { Activity, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
export function SyncButton() {
  const [isSyncing, setIsSyncing] = useState(false);
  const handleSync = () => {
    setIsSyncing(true);
    toast('Memulai sinkronisasi data...', {
      icon: <RefreshCw className="w-4 h-4 animate-spin" data-id="element-510" />
    });
    setTimeout(() => {
      setIsSyncing(false);
      toast.success('Sinkronisasi selesai. Data terbaru telah dimuat.');
    }, 2000);
  };
  return <button onClick={handleSync} disabled={isSyncing} className={`glass-panel px-3 py-1.5 rounded flex items-center gap-2 border-primary/30 hover:bg-primary/10 transition-colors ${isSyncing ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'}`} data-id="element-511">
      {isSyncing ? <RefreshCw className="w-3 h-3 text-primary animate-spin" data-id="element-512" /> : <span className="relative flex h-2 w-2" data-id="element-513">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" data-id="element-514"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" data-id="element-515"></span>
        </span>}
      <span className="text-xs font-mono text-primary tracking-widest" data-id="element-516">
        {isSyncing ? 'MENYINKRONKAN...' : 'SINKRONISASI AKTIF'}
      </span>
    </button>;
}